module.exports = "/lucky-balls/img/color_betting/red.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/color_betting/red.png
// module id = 982
// module chunks = 0